import { statuses } from "@/data/statuses";

export const filters = [
  { text: "All cases" },
  { text: "Forecasted", statusIndexes: [0, 1, 2, 3, 4, 7] },
  { text: "In progress", statusIndexes: [5, 6, 8] },
  { text: "Completed", statusIndexes: [9, 10] },
].map((item, i) => ({
  text: item.text,
  statuses: item.statusIndexes
    ? item.statusIndexes.map((el) =>
        el < statuses.length ? statuses[el].alias : "?"
      )
    : null,
  value: i + 1,
}));
